import React__default from 'react';
import styled, { css } from 'styled-components';
import { COLOR_PALETTE } from '../colors/colorPalette.js';
import { Icon } from '../icon/Icon.js';
import { Box } from '../layout/Box.js';
import '../layout/BulletList.js';
import '../layout/Column.js';
import '../layout/Columns.js';
import '../layout/Hidden.js';
import { Inline } from '../layout/Inline.js';
import '../layout/Stack.js';
import '../layout/VisuallyHidden.js';

const AVATAR_SIZE_REM = {
    small: 1,
    medium: 1.5,
    large: 2.25,
    xlarge: 3
};
const AVATAR_FONT_SIZE_REM = {
    small: 0.5,
    medium: 0.75,
    large: 1,
    xlarge: 1.25
};
/**
 * @deprecated These colors are deprecated within our system-wide color palette -
 * need to replace them with system color palette, but cannot currently due to legacy
 * Avatar implementations using this color set.
 */ const DEPRECATED_AVATAR_BG_COLORS = [
    "#BE81A3",
    "#ED847B",
    "#F0A950",
    "#D9C879",
    "#56BA88",
    "#4391AA",
    "#49ABD9",
    "#437DC0",
    "#8E81CF",
    "#DEA2FE"
];
/**
 * Generates a background colour for the given key
 * Key might represent an id or label
 */ const CSSGenerateBackgroundColor = ({ colorKey , isExternal  })=>{
    if (isExternal) {
        return css`
      background-color: ${COLOR_PALETTE.slateGrey10};
    `;
    }
    const colorKeyInt = parseInt(colorKey, 10);
    if (isNaN(colorKeyInt)) {
        return css`
      background-color: ${COLOR_PALETTE.slateGrey40};
    `;
    }
    return css`
    background-color: ${DEPRECATED_AVATAR_BG_COLORS[colorKeyInt % DEPRECATED_AVATAR_BG_COLORS.length]};
  `;
};
const CSSGenerateIconSize = (size)=>{
    return css`
    width: ${AVATAR_SIZE_REM[size]}rem;
    min-width: ${AVATAR_SIZE_REM[size]}rem;
    height: ${AVATAR_SIZE_REM[size]}rem;
    line-height: ${AVATAR_SIZE_REM[size] * 1.1}rem;
    border-radius: ${AVATAR_SIZE_REM[size] / 2}rem;
    font-size: ${AVATAR_FONT_SIZE_REM[size]}rem;
  `;
};
const StyledSpan = styled.span`
  color: white;
  font-size: 1rem;
  ${(props)=>CSSGenerateIconSize(props.size)}
  text-transform: uppercase;
  font-weight: 600;
  text-align: center;
  ${({ colorKey , isExternal  })=>CSSGenerateBackgroundColor({
        colorKey,
        isExternal
    })}
`;
const ICON_SIZE_REM = {
    xsmall: 1.25,
    small: 1.5,
    medium: 2,
    large: 2.5,
    xlarge: 3
};
const getSizeRem = (size)=>{
    const sizeRem = typeof size === "number" ? size : ICON_SIZE_REM[size];
    return sizeRem;
};
const StyledIcon = styled(Icon)`
  height: ${(props)=>getSizeRem(props.size) - 0.75}rem;
  width: ${(props)=>getSizeRem(props.size) - 0.75}rem;
  font-size: ${(props)=>getSizeRem(props.size) - 1}rem;
  line-height: ${(props)=>getSizeRem(props.size) - 1}rem;
`;
/**
 * User specific 'Avatar' Icon.
 *
 * @example
 * <Avatar>TT</Avatar>
 */ const Avatar = ({ size ="large" , initials ="?" , colorKey ="?" , isExternal =false , children , ...props })=>{
    return React__default.createElement(StyledSpan, {
        ...props,
        size: size,
        colorKey: colorKey,
        isExternal: isExternal,
        "data-hpy-web-avatar": true
    }, !!isExternal && React__default.createElement(Box, {
        width: "fill",
        height: "fill"
    }, React__default.createElement(Inline, {
        align: "center",
        alignY: "center",
        width: "fill"
    }, React__default.createElement(StyledIcon, {
        icon: "user",
        size: size,
        color: "slateGrey60"
    }))), !isExternal && !!children && children, !isExternal && !children && initials);
};
Avatar.dataId = "data-hpy-web-avatar";
Avatar.displayName = "Avatar";

export { Avatar };
